import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ERROR_ROUTES, HttpStatus } from '../constants/http.constants';
import { NotificationsService } from './notifications.service';
import { ErrorDto } from '@generated/be';
import { Router } from '@angular/router';

export const SKIP_ERROR_INTERCEPTOR_HEADER_KEY = 'Skip-Error-Interceptor';

export const errorApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.get(SKIP_ERROR_INTERCEPTOR_HEADER_KEY)) return next(req);
  const errorDispatcher = inject(NotificationsService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((e: HttpErrorResponse) => {
      errorNotification(e, errorDispatcher, router);
      return throwError(() => e.error);
    })
  );
};

function errorNotification(e: Partial<HttpErrorResponse>, errorDispatcher: NotificationsService, router: Router) {
  const error = e.error as ErrorDto;
  if (e.status === HttpStatus.NotFound) {
    console.warn('Stránka nenalezena.');
    errorDispatcher.dispatchError('Stránka nebyla nalezena');
    router.navigate([ERROR_ROUTES.NotFound]);
  } else if (e.status === HttpStatus.ServerError) {
    errorDispatcher.dispatchError('Vyskytla se systémová chyba. Pracujeme na jejím vyřešení.');
  } else if (e.status === HttpStatus.Forbidden) {
    errorDispatcher.dispatchError(error.description ?? 'Přístup k datům byl odepřen.', { life: 8_000 });
  } else if (e.status === HttpStatus.BadRequest) {
    errorDispatcher.dispatchError(error.description ?? 'Nesprávná vstupní data.', { life: 8_000 });
  } else if (e.status === HttpStatus.NotAllowed) {
    errorDispatcher.dispatchError('Tato akce není povolená.', { life: 5_000 });
  } else if (e.status === HttpStatus.Unauthorized) {
    errorDispatcher.clear();
    errorDispatcher.dispatchError(
      error?.description ?? 'Přístup k datům byl odepřen. Zkuste se odhlásit a znovu přihlásit.',
      { life: 4_000 }
    );
  } else if (e.status === HttpStatus.Conflict) {
    errorDispatcher.dispatchError(error.description ?? 'Položka již existuje.', { life: 4_000 });
  } else if (e.status === HttpStatus.EntityTooLarge) {
    errorDispatcher.dispatchError(error.description ?? 'Soubor je moc velký.', { life: 4_000 });
  } else if (e.status === HttpStatus.Timeout) {
    errorDispatcher.dispatchError(error.description ?? 'Vypršel časový limit pro požadavek.', { life: 4_000 });
  } else {
    errorDispatcher.dispatchError('Neznámá chyba.');
  }
}
